import { useState, useEffect } from "react";
import {
  useGetCartListQuery,
  useGetOvensQuery,
} from "../../processing/cooking/cookingApi";
import { useCreateHumidOvenDataMutation, useUpdateHumidOvenDataMutation } from "../humid/humidApi";
import { Col, Row } from "react-bootstrap";
import SelectBox from "../../../components/shared/fields/SelectBox ";
import InputWithLabel from "../../../components/shared/fields/InputWithLabel";
import CommonModal from "../../../components/shared/modalLayout/CommonModal";
import Button from "../../../components/shared/buttons/button";
import { useGetPackingSummaryQuery } from "../packing/packingApi";
import toast from "react-hot-toast";
import { newIncreasingDate } from "../../../components/shared/utils";
import useTranslator from "../../../hooks/useTranslator";
import { convertToUserTimezone, getCurrentDate, getCurrentDateTime , makePriorLotNumber } from "../../../helpers/Utils";

const HumidityModal = ({ show, setShow, record, mode, type_name, date }) => {
  // console.log('adsfdf')
  const { _t } = useTranslator();
  const [createData] = useCreateHumidOvenDataMutation();
  const [updateData] = useUpdateHumidOvenDataMutation();
  const [status] = useState("available");
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const lotNumber = makePriorLotNumber(currentDate);
  const shouldSelectType = mode === "add" && !type_name;
  const isViewOnly = mode === "view";

  const treyCountConfig = {
    "cheeks/strips": [
      { name: "cheeks_trey_count", label: _t("cheeks_trey_count", "Cheeks Trey Count") },
      { name: "strips_trey_count", label: _t("strips_trey_count", "Strips Trey Count") },
    ],
    "cheeks/tapita": [
      { name: "cheeks_trey_count", label: _t("cheeks_trey_count", "Cheeks Trey Count") },
      { name: "tapita_trey_count", label: _t("tapita_trey_count", "Tapita Trey Count") },
    ],
    "cheeks": [{ name: "cheeks_trey_count", label: _t("cheeks_trey_count", "Cheeks Trey Count") }],
    "strips": [{ name: "strips_trey_count", label: _t("strips_trey_count", "Strips Trey Count") }],
    "tapita": [{ name: "tapita_trey_count", label: _t("tapita_trey_count", "Tapita Trey Count") }],
  };


  const initialFormData = {
    date_time_entered: "",
    status: mode === "add" ? "cooking" : "",
    date: currentDate,
    treys_count: "",
    cheeks_trey_count: "",
    strips_trey_count: "",
    tapita_trey_count: "",
    time_end: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
    time_entered: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
    type: type_name || "",
    cart_number_id: "",
    oven_id: "",
    oven: {},
    cheeks_cart_weight: 0,
    strips_cart_weight: 0,
    cart_number: {},
    data_from: "rework",
    data_type: "humidity",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [ovenId, setOvenId] = useState(null);

  useEffect(() => {
    if (mode === "edit" && record?.oven?.id) {
      setOvenId(record.oven.id);
    }
  }, [mode, record]);
  const { data: ovenList } = useGetOvensQuery({
    status,
    ...(ovenId ? { oven_id: ovenId } : {}),
  });
  const { data: cartsList, refetch: refetchCartList } = useGetCartListQuery({ status });
  const { data: summaryData } = useGetPackingSummaryQuery({
    tab: "humidity",
    date,
  });

  
  useEffect(() => {
    if (mode === "edit" && record) {
      const updatedFormData = { ...initialFormData };

      for (const key in record) {
        if (key === "oven") updatedFormData["oven_id"] = record.oven.id;
        if (key === "type") updatedFormData["type_id"] = record.type.id;
        if (key === "cart_number")
          updatedFormData["cart_number_id"] = record.cart_number.id;
        if (key in initialFormData) updatedFormData[key] = record[key];
      }

      // Extract only HH:mm from YYYY-MM-DD HH:mm:ss format
      updatedFormData.time_entered = record.time_entered ? convertToUserTimezone(record.time_entered, "YYYY-MM-DDTHH:mm") : "";
      updatedFormData.time_end = record.time_end ? convertToUserTimezone(record.time_end, "YYYY-MM-DDTHH:mm") : "";
      setFormData(updatedFormData);
    } else {
      setFormData({
        ...initialFormData,
        time_entered: getCurrentDateTime("YYYY-MM-DDTHH:mm"),
      });
    }
  }, [mode, record, show]);



  const isCartAvailable = (cart) =>
    cart.status === "available" || cart.id == record?.cart_number?.id;

  const handleClose = () => {
    setShow(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.type) {
      toast.error(_t("select_type_error", "Please select type."));
      return;
    }

    // Get total weight limits from summaryData
    const totalKgCheeks = summaryData?.data?.total_kg_cheeks_in_humidity || 0;
    const totalKgStrips = summaryData?.data?.total_kg_strips_in_humidity || 0;

    // Validation
    if (
      formData.type === "cheeks" &&
      formData.cheeks_cart_weight > totalKgCheeks
    ) {
      toast.error(_t("cheeks_cart_weight_exceed", "Cart weight cannot exceed :kg kg for Cheeks.", { kg: totalKgCheeks }));
      return;
    }
    if (
      formData.type === "strips" &&
      formData.strips_cart_weight > totalKgStrips
    ) {
      toast.error(_t("strips_cart_weight_exceed", "Cart weight cannot exceed :kg kg for Strips.", { kg: totalKgStrips }));
      return;
    }
    const payload = {
      ...formData,
      cheeks_trey_count: parseInt(formData.cheeks_trey_count) || 0,
      strips_trey_count: parseInt(formData.strips_trey_count) || 0,
      tapita_trey_count: parseInt(formData.tapita_trey_count) || 0,
      treys_count: parseInt(formData.treys_count) || 0,
      data_type: "humidity",
    };
    const mutation = mode === "add" ? createData : updateData;

    try {
      await mutation(
        mode === "add" ? payload : { id: record.id, requestBody: payload }
      ).unwrap();
      refetchCartList();
      handleClose();
    } catch (error) {
      console.error("Error creating/updating manager:", error);
    }
  };

  const TREY_FIELDS = ["cheeks_trey_count", "strips_trey_count", "tapita_trey_count"];

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Reset trey count fields when type changes
    if (name === "type") {
      setFormData((prev) => ({
        ...prev,
        cheeks_trey_count: "",
        strips_trey_count: "",
        tapita_trey_count: "",
        treys_count: 0,
      }));
    }

    // Auto-calculate time_end based on type and time_entered
    if ((name === "time_entered" && formData.type !== "") || name === "type") {
      const selectedType = name === "type" ? value : formData.type;
      const defaultTime = name === "time_entered" ? value : formData.time_entered;

      const minutesMap = {
        "cheeks": 120,
        "strips": 120,
        "cheeks/strips": 120,
        "tapita": 120,
        "cheeks/tapita": 120,
      };

      const minutes = minutesMap[selectedType];
      if (minutes) {
        const expEndTime = newIncreasingDate(minutes, defaultTime);
        setFormData((prev) => ({ ...prev, time_end: expEndTime }));
      }
    }

    // Auto-sum treys_count when any trey field changes
    if (TREY_FIELDS.includes(name)) {
      const updated = { ...formData, [name]: value };
      const total = TREY_FIELDS.reduce((sum, key) => sum + (parseInt(updated[key]) || 0), 0);
      setFormData((prev) => ({ ...prev, [name]: value, treys_count: total }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  const renderFormFields = () => (
    <>
      {/* 1. Oven */}
      <Col lg={6}>
        <SelectBox
          label={_t("select_oven", "Select Oven")}
          name="oven_id"
          value={formData.oven_id}
          options={(ovenList?.data || []).map((list) => ({ value: list.id, label: _t(list.name, list.name) }))}
          onChange={handleChange}
        />
      </Col>
      {/* 2. Cart Number */}
      <Col lg={6}>
        <SelectBox
          label={_t("carts_number", "Carts Number")}
          name="cart_number_id"
          value={formData.cart_number_id}
          options={(cartsList?.data || []).map((list) => ({
            value: list.id,
            label: list.name,
            disabled: !isCartAvailable(list),
          }))}
          onChange={handleChange}
          disabled={mode === "edit" || isViewOnly}
        />
      </Col>
     

      <Col lg={6}>
        {shouldSelectType ? (
          <SelectBox
            label={_t("type", "Type")}
            name="type"
            value={formData.type}
            options={[
              { value: "cheeks", label: _t("type_cheeks", "Cheeks") },
              { value: "strips", label: _t("type_strips", "Strips") },
              { value: "cheeks/strips", label: _t("type_cheeks_strips", "Cheeks/Strips") },
              { value: "tapita", label: _t("type_tapita", "Tapita") },
              { value: "cheeks/tapita", label: _t("type_cheeks_tapita", "Cheeks/Tapita") },
            ]}
            onChange={handleChange}
          />
        ) : (
          <InputWithLabel label={_t("type", "Type")} type="text" name="type" value={formData.type} onChange={handleChange} disabled={true} />
        )}
      </Col>
     

{/* <Row> */}
      {/* 4. Time Entered */}
      <Col lg={6}>
        <InputWithLabel label={_t("time_entered", "Time Entered")} type="datetime-local" name="time_entered" value={formData.time_entered} onChange={handleChange} disabled={true} />
      </Col>
      {/* 5. Time End */}
      <Col lg={6}>
        <InputWithLabel label={_t("time_end", "Time End")} type="datetime-local" name="time_end" value={formData.time_end} onChange={handleChange} disabled={isViewOnly} />
      </Col>
     
      {/* 7. Trey Count (dynamic) */}
      {treyCountConfig[formData.type] ? (
        treyCountConfig[formData.type].map((field) => (
          <Col lg={6} key={field.name}>
            <InputWithLabel label={field.label} type="number" name={field.name} value={formData[field.name]} onChange={handleChange} placeholder={"0"} min={0} disabled={mode === "edit" || isViewOnly} />
          </Col>
        ))
      ) : (
        <Col lg={6}>
          <InputWithLabel label={_t("treys_count", "Treys Count")} type="number" name="treys_count" value={formData.treys_count} onChange={handleChange} disabled={mode === "edit" || isViewOnly} placeholder={"0"} />
        </Col>
      )}
      {/* 8. Status */}
      <Col lg={6}>
        <SelectBox
          label={_t("status", "Status")}
          name="status"
          value={formData?.status}
          disabled={isViewOnly}
          options={
            mode === "add"
              ? [
                  { value: "cooking", label: _t("cooking", "Cooking") },
                  { value: "cooling_room", label: _t("cooling_room", "Cooling Room") },
                ]
              : [
                  { value: "cooking", label: _t("cooking", "Cooking"), disabled: true },
                  { value: "cooling_room", label: _t("cooling_room", "Cooling Room") },
                  { value: "cart_unloaded", label: _t("cart_unloaded", "Cart Unloaded") },
                ]
          }
          onChange={handleChange}
        />
      </Col>
      {/* </Row> */}
    </>
  );

  return (
    <CommonModal
      show={show}
      handleClose={handleClose}
      setShow={setShow}
      title={
        mode === "add" ? _t("add_title", "Adding Humidity Data")
          : _t("edit_title", "Cooling Room to Packing Area")
      }
      children={formData}
    >
      <Row>{renderFormFields()}</Row>

      <Row>
        <Col className="text-end">
          {!isViewOnly && (
            <Button
              label={_t("save_changes", "Save Changes")}
              size="small"
              onClick={handleSubmit}
            />
          )}
        </Col>
      </Row>
    </CommonModal>
  );
};

export default HumidityModal;
